import { __ } from "@wordpress/i18n";

/**
 * Limits enforced by the external ES quote/payment API.
 */
export const QUOTE_PAYMENT_PROPERTY_VALUE_MIN = 1000;
export const QUOTE_PAYMENT_PROPERTY_VALUE_MAX = 20000000;
export const QUOTE_PAYMENT_LOAN_TERM_MIN = 1;
export const QUOTE_PAYMENT_LOAN_TERM_MAX = 40;

/** Constants for i18n labels */
export const QUOTE_PAYMENT_LABELS = {
    title: __("Dados para a simulação", "df-simulators"),
    propertyValue: __("Preço do imóvel", "df-simulators"),
    downPaymentAmount: __("Capitais próprios", "df-simulators"),
    loanTermInYears: __("Prazo", "df-simulators"),
    rateType: __("Tipo de taxa de juro", "df-simulators"),
    region: __("Local do imóvel", "df-simulators"),
    condition: __("Condição do imóvel", "df-simulators"),
};

/** Options for select/radio fields */
export const QUOTE_PAYMENT_OPTIONS = {
    rateType: [
        { value: "FIXED", label: __("Fixa", "df-simulators") },
        { value: "VARIABLE", label: __("Variável", "df-simulators") },
    ],
    condition: [
        { value: "NUEVA", label: __("Novo", "df-simulators") },
        { value: "USADA", label: __("Usado", "df-simulators") },
    ],
    region: [
        { value: "ANDALUCIA", label: "Andalucía" },
        { value: "ARAGON", label: "Aragón" },
        { value: "ASTURIAS", label: "Asturias" },
        { value: "CANARIAS", label: "Canarias" },
        { value: "CANTABRIA", label: "Cantabria" },
        { value: "CASTILLA_LA_MANCHA", label: "Castilla-La Mancha" },
        { value: "CASTILLA_Y_LEON", label: "Castilla y León" },
        { value: "CATALUNA", label: "Cataluña" },
        { value: "CEUTA", label: "Ceuta" },
        { value: "COMUNITAT_VALENCIANA", label: "Comunitat Valenciana" },
        { value: "EXTREMADURA", label: "Extremadura" },
        { value: "GALICIA", label: "Galicia" },
        { value: "ILLES_BALEARS", label: "Illes Balears" },
        { value: "LA_RIOJA", label: "La Rioja" },
        { value: "MADRID", label: "Comunidad de Madrid" },
        { value: "MELILLA", label: "Melilla" },
        { value: "MURCIA", label: "Región de Murcia" },
        { value: "NAVARRA", label: "Comunidad Foral de Navarra" },
        { value: "PAIS_VASCO", label: "País Vasco" },
    ],
    loanTermInYears: Array.from(
        { length: QUOTE_PAYMENT_LOAN_TERM_MAX - QUOTE_PAYMENT_LOAN_TERM_MIN + 1 },
        (_, index) => {
            const years = QUOTE_PAYMENT_LOAN_TERM_MIN + index;
            return { value: years.toString(), label: years.toString() };
        }
    ),
};
